import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const compatibilityRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/compatibility",
  component: lazyRouteComponent(() => import("./lazy-pages"), "CompatibilityPage"),
})
